module.exports = __webpack_public_path__ + "static/media/left_candy_cane.c4ad0766.svg";